import React, { useState } from "react";

import { useHistory } from "react-router-dom";

import { Checkbox, Space } from "antd";

import { statusTransactionConfig, statusAuditLogConfig } from "./statusConfig";

import styles from "./menu.module.scss";

const Menu = ({ closeDropdown, setFilter, removeFilter }) => {
  const history = useHistory();

  const [valuesArray, setValuesArray] = useState([]);

  const onSubmit = () => {
    const name = "status";
    if (!valuesArray.length) {
      removeFilter(name);
    } else {
      const value = valuesArray;
      setFilter(name, value);
    }
    closeDropdown(false);
  };

  const onRemove = () => {
    closeDropdown(false);
    setValuesArray([]);
    removeFilter("status");
  };

  const onChange = (values) => {
    setValuesArray(values);
  };

  return (
    <div className={styles.menuContainer}>
      <div className={styles.formContainer}>
        <Space direction="vertical" size="large">
          <Checkbox.Group
            className={styles.checkboxContainer}
            options={
              history.location.pathname === "/main/transactions"
                ? statusTransactionConfig
                : statusAuditLogConfig
            }
            value={valuesArray}
            onChange={onChange}
          ></Checkbox.Group>
          <Space direction="horizontal" size="large">
            <button
              className="primary"
              onClick={onSubmit}
              style={{ width: "90px" }}
            >
              Apply
            </button>
            <button
              className="secondary"
              style={{ width: "90px" }}
              onClick={onRemove}
            >
              Remove
            </button>
          </Space>
        </Space>
      </div>
    </div>
  );
};

export default Menu;
